/* @flow */
import type { Action, AsyncAction, TrackSearchFullParams } from '../../types';

import api from '../../services/api';

const onFailure = (error: Object) => console.warn(error);

const setTrackSearch = (params: TrackSearchFullParams): Action => {
  return {
    type: 'SET_TRACK_SEARCH',
    payload: params,
  };
};

const performTrackSearch = (params: TrackSearchFullParams): AsyncAction => {
  //$FlowFixMe
  return {
    type: 'PERFORM_TRACK_SEARCH_REQUEST',
    payload: params,
    promise: params.text ? api.tracks.find(params) : Promise.resolve({ total: 0, hits: [] }),
    meta: { onFailure },
  };
};

const fetchTrackSearchPage = (params: TrackSearchFullParams): AsyncAction => {
  //$FlowFixMe
  return {
    type: 'FETCH_TRACK_SEARCH_PAGE_REQUEST',
    payload: params,
    promise: api.tracks.find(params),
    meta: { onFailure },
  };
};

const toggleSelectTrack = (index: number): Action => {
  return { type: 'TOGGLE_SELECT_TRACK', payload: index };
};

const toggleSelectAllTracks = (): Action => {
  return { type: 'TOGGLE_SELECT_ALL_TRACKS' };
};

const trackSearchSetPageScroll = (pageScroll: number): Action => {
  return {
    type: 'TRACK_SEARCH_SCROLL_PAGE',
    payload: pageScroll,
  };
};

const trackSearchExpandTrack = (trackId: number, isExpanded: boolean): Action => {
  return {
    type: 'TRACK_SEARCH_EXPAND_TRACK',
    payload: {
      trackId,
      isExpanded,
    },
  };
};

const trackSearchToggleSelectTracks = (trackIds: number[]): Action => {
  return {
    type: 'TRACK_SEARCH_TOGGLE_SELECT_TRACKS',
    payload: trackIds,
  };
};

const trackSearchToggleExpandSelectedTracks = (): Action => {
  return {
    type: 'TRACK_SEARCH_TOGGLE_EXPAND_SELECTED_TRACKS',
  };
};

export default {
  setTrackSearch,
  performTrackSearch,
  fetchTrackSearchPage,
  toggleSelectTrack,
  toggleSelectAllTracks,
  trackSearchSetPageScroll,
  trackSearchExpandTrack,
  trackSearchToggleSelectTracks,
  trackSearchToggleExpandSelectedTracks,
};
